const mediaData = [
  {
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20costume%20drama%20cinematic%20still%20with%20a%20female%20lead%20in%20traditional%20hanfu%20standing%20by%20a%20moonlit%20lake%2C%20ethereal%20mist%20and%20soft%20warm%20lantern%20light%2C%20dreamy%20romantic%20atmosphere%2C%20film%20quality%20cinematography%2C%20warm%20coral%20and%20amber%20tones%2C%20shallow%20depth%20of%20field&width=600&height=340&seq=media-1-2026&orientation=landscape',
    title: '长相思 第二季 · 终极预告',
    duration: '02:35',
    views: '1280万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20Korean%20drama%20cinematic%20scene%20with%20two%20stylish%20protagonists%20having%20coffee%20at%20a%20rooftop%20cafe%20overlooking%20city%20skyline%2C%20golden%20hour%20warm%20lighting%2C%20soft%20romantic%20atmosphere%2C%20high%20quality%20drama%20production%20still%2C%20warm%20terracotta%20and%20cream%20palette&width=600&height=340&seq=media-2-2026&orientation=landscape',
    title: '你比星光美丽 · 高甜混剪',
    duration: '04:12',
    views: '965万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20historical%20Chinese%20drama%20scene%20with%20a%20powerful%20male%20lead%20in%20imperial%20robes%20standing%20in%20a%20grand%20palace%20hall%2C%20warm%20golden%20light%20streaming%20through%20traditional%20lattice%20windows%2C%20cinematic%20wide%20composition%2C%20epic%20scale%20and%20majestic%20atmosphere%2C%20rich%20warm%20amber%20color%20grading&width=600&height=340&seq=media-3-2026&orientation=landscape',
    title: '庆余年 第二季 · 名场面',
    duration: '03:48',
    views: '852万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20drama%20cinematic%20still%20with%20a%20detective%20examining%20evidence%20under%20warm%20desk%20lamp%20in%20a%20dark%20room%2C%20atmospheric%20moody%20lighting%2C%20film%20noir%20aesthetic%2C%20professional%20cinematography%20with%20high%20contrast%2C%20warm%20brown%20and%20shadow%20tones&width=600&height=340&seq=media-4-2026&orientation=landscape',
    title: '墨雨云间 · 悬疑特辑',
    duration: '05:20',
    views: '738万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Heartwarming%20slice%20of%20life%20Japanese%20drama%20scene%20with%20two%20friends%20walking%20through%20cherry%20blossom%20lined%20street%20in%20spring%2C%20soft%20natural%20light%2C%20gentle%20and%20nostalgic%20mood%2C%20warm%20pastel%20color%20palette%2C%20cinematic%20composition%2C%20high%20quality%20drama%20photography&width=600&height=340&seq=media-5-2026&orientation=landscape',
    title: '重启人生 · 治愈片段集',
    duration: '06:15',
    views: '621万',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精彩剧集</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">精选热门剧集精彩片段、预告片和花絮，先睹为快</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.map((item, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all cursor-pointer">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/25 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs whitespace-nowrap">{item.duration}</span>
                <span className="absolute top-2 right-2 text-white text-xs bg-black/40 px-2 py-0.5 rounded whitespace-nowrap">
                  <i className="ri-eye-line mr-1"></i>{item.views}
                </span>
              </div>
              <div className="p-3">
                <h3 className="font-medium text-foreground-900 text-sm group-hover:text-primary-500 transition-colors truncate">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}